module.exports = __webpack_public_path__ + "img/29.9eabb54e.png";